export default "__VITE_ASSET__DDwGkzqU__"